module.exports = __webpack_public_path__ + "static/SFUIText-Regular-db7e3af00ee9c2bb299f8d31f4ffcb1c.woff";